import { Action, Dispatch, MiddlewareAPI } from 'redux';

export type ReduxListener = (action: Action) => any;

export const listeners: Record<any, Record<string, ReduxListener>> = {};

export const registerListener = (key: string, action: any, listener: ReduxListener) => {
	if (!(action in listeners)) {
		listeners[action] = {};
	}

	listeners[action][key] = listener;
};

export const deregisterListener = (key: string, action: any) => {
	delete listeners[action][key];
};

export const getListenersForAction = (action: any): ReduxListener[] => {
	if (!(action in listeners)) {
		return [];
	}

	return Object.values(listeners[action]);
};

export const pubSub = (store: MiddlewareAPI) => (next: Dispatch) => (action: Action) => {
	const actionListeners = getListenersForAction(action.type);
	for (const listener of actionListeners) {
		listener(action);
	}

	return next(action);
};
